
import NewItems from "features/inventory/NewItems"

const NewInventoryItemsPage = () => {
    return (
        <NewItems />
    )
}

export default NewInventoryItemsPage